import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { ParticipantTypeEnumText } from "../../models/ParticipantTypeEnum"
import { participantsApi } from "../../utils"
import { throwApiError } from "../lms-shared/store/error-handling-actions"
import PostPopUp from "../Pages/Dashboard/Friends/Share/PostPopUp"
import checkWithCircleIcon from '../../assests/project/checkWithCircleIcon.png'
import ShareIcon from '../../assests/project/share.png'
import classes from './ShareProjectBtn.module.css'
import { onKeyDown } from "../../service"

const ShareProjectBtn = ({ project, setMessage, saveProjectCallback }) => {

    const texts = useSelector(state => state.translate.texts);
    const studyGroup = useSelector(state => state.topics.studyGroup);

    const [beenSharedBefore, setBeenSharedBefore] = useState(project?.isShared)
    const dispatch = useDispatch()
    const { studyGroupId } = useParams()

    function shareProject() {
        let myData = {
            studyGroupId: studyGroupId,
            participantType: ParticipantTypeEnumText.student,
        }
        if (studyGroup && !studyGroup.allowSelfRegister) {
            participantsApi.participantsFilterRangePost({ participantsRangeFilter: myData }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.participantsAddError, error: error, statusCode: response?.statusCode, message: "participantsAddPost " + error.message, level: 2, component: "CurriculumPage", line: 36 }))
                }
                else {
                    setMessage(<PostPopUp close={() => setMessage(false)} project={project} beenSharedBefore={beenSharedBefore} setBeenSharedBefore={setBeenSharedBefore} friendsData={response.body} saveVersion={saveProjectCallback}></PostPopUp>)
                }
            })
        }
        else {
            setMessage(<PostPopUp close={() => setMessage(false)} project={project} beenSharedBefore={beenSharedBefore} setBeenSharedBefore={setBeenSharedBefore} saveVersion={saveProjectCallback}></PostPopUp>)
        }
    }


    return (
        <>
            <div className={classes.ShareIconContainer} onClick={shareProject} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, shareProject)}>
                {beenSharedBefore && <img className={classes.checkIcon} src={checkWithCircleIcon} alt="CheckIcon" />}
                <img className={`${classes.ShareIcon} ${classes.Icon}`} src={ShareIcon} alt="ShareIcon" />
            </div>
            <div className={`${classes.Tooltip} ${classes.Share}`}>{texts.share}</div>
        </>
    )
}

export default ShareProjectBtn;